import React, { ComponentType, ElementType, ReactNode, useMemo } from 'react';
import classNames from 'classnames';
import { pickBy } from 'lodash/fp';
import { htmlAttributes } from 'src/client/helpers/htmlAttributes';
import { Link, NavLink } from 'react-router-dom';

export type Props = {
  active?: boolean;
  as?: ComponentType | ElementType;
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  name?: string | number | ReactNode;
  onClick?: (value?: string) => void;
  value?: string;

  // Rest Props
  [value: string]: unknown;
};

const pickAllowed = pickBy((value: unknown, key: string) => htmlAttributes.includes(key));

export const Tab = (props: Props) => {
  const { as: Component = 'a', active, className, disabled, onClick, value, children, name, to, ...rest } = props;

  const handleClick = () => {
    if (disabled || active || !onClick) return;
    onClick(value);
  };

  const restProps = useMemo(() => pickAllowed(rest), [rest]);

  if (Component === (Link || NavLink)) {
    restProps.to = to;
  }

  return (
    <Component className={classNames('tab', className, { active, disabled })} onClick={handleClick} {...restProps}>
      {name || children}
    </Component>
  );
};
